import {c as createCommonjsModule} from "./_commonjsHelpers-8c19dec8.js";
var utils = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getTransitionProps = getTransitionProps;
  exports.reflow = void 0;
  const reflow = (node) => node.scrollTop;
  exports.reflow = reflow;
  function getTransitionProps(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const {
      timeout,
      easing,
      style = {}
    } = props;
    return {
      duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
      easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
      delay: style.transitionDelay
    };
  }
});
export {utils as u};
